import { createReducer } from 'app-webtech-core/reducers/createReducer';
import { PAIRED_DEVICES_STATE_STATUSES } from '../constants';
import { ACTIVATE, FETCH_ALL, REMOVE } from '../actions/types';
import {
  pairedDevicesFetchAllFailureReducer,
  pairedDevicesFetchAllRequestReducer,
  pairedDevicesFetchAllSuccessReducer,
} from './fetchAll';
import {
  pairedDevicesRemoveFailureReducer,
  pairedDevicesRemoveRequestReducer,
  pairedDevicesRemoveSuccessReducer,
} from './remove';
import {
  pairedDevicesActivateFailureReducer,
  pairedDevicesActivateRequestReducer,
  pairedDevicesActivateSuccessReducer,
} from './activate';

export const defaultState = {
  list: [],
  status: PAIRED_DEVICES_STATE_STATUSES.EMPTY,
  error: null,
};

export const pairedDevicesReducer = createReducer(defaultState, {
  [FETCH_ALL.REQUEST]: pairedDevicesFetchAllRequestReducer,
  [FETCH_ALL.FAILURE]: pairedDevicesFetchAllFailureReducer,
  [FETCH_ALL.SUCCESS]: pairedDevicesFetchAllSuccessReducer,

  [REMOVE.REQUEST]: pairedDevicesRemoveRequestReducer,
  [REMOVE.FAILURE]: pairedDevicesRemoveFailureReducer,
  [REMOVE.SUCCESS]: pairedDevicesRemoveSuccessReducer,

  [ACTIVATE.REQUEST]: pairedDevicesActivateRequestReducer,
  [ACTIVATE.FAILURE]: pairedDevicesActivateFailureReducer,
  [ACTIVATE.SUCCESS]: pairedDevicesActivateSuccessReducer,
});
